<template>
    <div class="position-box">
        <div class="head">
            <img class="icon" v-if="theme" :src="touxiang2" alt="">
            <img class="icon" v-else :src="touxiang" alt="">
            <!-- <div class="title">{{$t('footer.home')}}</div> -->
            <div @click="goUser" class="lang">
              <img class="icon2" v-if="!theme" src="@/assets/new2/me-black.png" alt="">
              <img class="icon2" v-else src="@/assets/new2/me-light.png" alt="">
            </div>
        </div>
        <div class="cotainer">
            <div class="banner-wrap" v-show="bannerList.length > 0">
                <swiper class="banner-box swiper" ref="mySwiper" :options="swiperOption">
                    <swiper-slide class="banner" v-for="(item,index) in bannerList" :key="index"><img class="img" :src="item.url" alt="banner"></swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
                <!-- <div class="banner-box swiper-wrapper" ref="mySwiper">
                    <div class="banner swiper-slide" v-for="(item,index) in bannerList" :key="index" :data-index="index"><img class="img" :src="item.url" alt=""></div>
                </div>
                <div class="swiper-pagination"></div> -->
            </div>
            <div class="notice-box" v-show="noticeList.length > 0" v-if="lang == 'ar'">
              <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
              <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
              <ul class="notice">
                  <swiper class="swiper" ref="mySwipers" :options="swiperOption2">
                      <swiper-slide class="text" v-for="(item,index) in noticeList" :key="index">{{item.title}}</swiper-slide>
                  </swiper>
                  <!-- <li class="text">公告</li> -->
              </ul>
              <img class="icon" v-if="theme" src="@/assets/theme/notice.png" alt="">
              <img class="icon" v-else src="@/assets/notify.png" alt="">
            </div>
            <div class="notice-box" v-show="noticeList.length > 0" v-else>
                <img class="icon" v-if="theme" src="@/assets/theme/notice.png" alt="">
                <img class="icon" v-else src="@/assets/notify.png" alt="">
                <ul class="notice">
                    <swiper class="swiper" ref="mySwipers" :options="swiperOption2">
                        <swiper-slide class="text" v-for="(item,index) in noticeList" :key="index">{{item.title}}</swiper-slide>
                    </swiper>
                    <!-- <li class="text">公告</li> -->
                </ul>
                <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
            </div>
            <ul class="item-box">
                <li class="item" @click="jump2('deposit')">
                    <img class="icon" src="@/assets/user/chongbi.png" alt="">
                    <div class="text">{{$t('assets.cmoney')}}</div>
                </li>
                <router-link class="item" tag="li" to="/benefits">
                    <img class="icon" src="@/assets/new2/fuli.png" alt="">
                    <div class="text">{{$t('langNew2.flzq')}}</div>
                </router-link>
                <li class="item" v-show="temp_user" @click="create">
                    <img class="icon" src="@/assets/new2/monijiaoyi.png" alt="">
                    <div class="text" v-if="!isMn">{{$t('tipsNew.cjxnzh')}}</div>
                    <div class="text" v-else>{{$t('langNew.tcmnzh')}}</div>
                </li>
                <li class="item" @click="service">
                    <img class="icon" src="@/assets/user/kefu.png" alt="">
                    <div class="text">{{$t('index.zxkf')}}</div>
                </li>
                <router-link class="item" tag="li" to="/contractTransaction">
                    <img class="icon" src="@/assets/index/heyue.png" alt="">
                    <div class="text">{{$t('jghy.jghy')}}</div>
                </router-link>
                <router-link class="item" tag="li" to="/subscription">
                    <img class="icon" src="@/assets/index/icon-xbsg.png" alt="">
                    <div class="text">{{$t('xbsg.title')}}</div>
                </router-link>
                <router-link class="item" tag="li" to="/propagate">
                    <img class="icon" src="@/assets/index/px.png" alt="">
                    <div class="text">{{$t('bzhl.title')}}</div>
                </router-link>
                <router-link class="item" tag="li" to="/currency">
                    <img class="icon" src="@/assets/index/icon-wydb.png" alt="">
                    <div class="text">{{$t('wydb.title')}}</div>
                </router-link>
                <!-- <router-link class="item" tag="li" to="/help">
                    <img class="icon" src="@/assets/index/icon-bzzx.png" alt="">
                    <div class="text">{{$t('my.hc')}}</div>
                </router-link> -->
            </ul>
            <ul class="coin-box">
                <li class="coin-li" v-for="(item, index) in listData" :key="index" @click="jump(item.symbol)">
                    <div class="coin-head">
                        <img class="icon" v-if="item.icon && item.type == 1" :src="item.icon" alt="">
                        <div class="text">{{item.name | rewriteName}}/<span class="t1">USDT</span></div>
                    </div>
                    <div class="price">{{item.new_price || 0.00 | toFixed4}}</div>
                    <div class="change" :class="{red: item.grow < 0}"><img v-if="item.grow < 0" class="arrow die" src="@/assets/arrow_icon_red.png" alt=""><img v-else class="arrow" src="@/assets/arrow_icon.png" alt="">{{item.grow || 0.00 }}%</div>
                </li>
            </ul>
            <!-- <div class="line"></div>             -->
            <div class="line"></div>
            <ul class="tab-box">
              <li class="tab" :class="{active: type == 2}" @click="tab(2)">{{$t('langNew.gjs')}}</li>
              <li class="tab" :class="{active: type == 3}" @click="tab(3)">{{$t('langNew.yy')}}</li>
              <li class="tab" :class="{active: type == 1}" @click="tab(1)">{{$t('langNew.szhb')}}</li>
            </ul>
            <ul class="table-head">
                <li class="th">{{$t('mk.name')}}</li>
                <li class="th text-center">{{$t('mk.newPrice')}}</li>
                <li class="th text-right">{{$t('mk.rank')}}</li>
            </ul>
            <ul class="table-body">
                <li class="tr" v-for="(item, index) in listData" :key="index" @click="jump(item.symbol)">
                    <div class="item coin">
                        <img class="icon" v-if="item.type == 1" :src="item.icon" alt="">
                        <div class="t1">{{item.name | rewriteName}}/<span class="t2">USDT</span></div>
                    </div>
                    <div class="item price text-center">{{item.new_price || 0.00 | toFixed4}}</div>
                    <div class="item change text-right"><span class="persent" :class="{'bg-red': item.grow < 0}">{{item.grow || 0.000 | toFixed2}}%</span></div>
                </li>
                <!-- <li class="tr">
                    <div class="item coin">
                        <img class="icon" src="@/assets/BTC.png" alt="">
                        <div class="t1">BTC/<span class="t2">USDT</span></div>
                    </div>
                    <div class="item price text-center">7709.72</div>
                    <div class="item change text-right"><span class="persent bg-red">-0.26%</span></div>
                </li>                -->
            </ul>
        </div>
        <!-- 下载弹窗 -->
        <div class="download-box" v-show="isShow && !isPhone">
            <img class="logo" :src="logo" alt="">
            <div class="text-box">
                <p class="t1">{{this.project}}</p>
                <p class="t2">{{$t('download.t1')}}</p>
            </div>
            <a class="btn" @click="link">{{$t('download.xz')}}</a>
            <img class="btn-close" @click="downLoadClose" src="@/assets/close.png" alt="">
        </div>
        <!-- 公告弹窗 -->
        <div class="mask-notice" v-show="isNotice">
            <div class="notice-wrap">
                <div class="title">{{$t('news.gg')}}</div>
                <div class="cont" v-html="noticeHtml"></div>
                <div class="notice-btn btn-bg" @click="goDetail">{{$t('news.ckxq')}}</div>
                <img class="btn-close" @click="noticeClose" src="@/assets/Log-In_delete.png" alt="">
            </div>
        </div>
        <!-- 添加到主屏幕弹窗 -->
        <div class="alert-zpm-wrap" v-show="zpmShow && isPhone" @click="zpmClose">
            <div class="alert-zpm-box">
                <div class="zpm-head">
                    <div class="title">
                        <div class="t1">{{$t('indexNew.title')}}</div>
                        <img class="close" src="@/assets/close2.png" @click="zpmClose" alt="">
                    </div>
                    <div class="t2">{{$t('indexNew.t1')}}</div>
                </div>
                <div class="zpm-cont">
                    <img class="zpm-logo" src="@/assets/logo.png" alt="">
                    <div class="zpm-title">{{projectTitle}}</div>
                    <img class="img" src="@/assets/zpm/zpm-img01.jpg" alt="">
                    <ul class="item1-zpm-box">
                        <li class="text">{{$t('indexNew.t2')}}</li>
                        <li><img class="icon" src="@/assets/zpm/zpm-img02.png" alt=""></li>
                    </ul>
                    <ul class="item2-zpm-box">
                        <li class="text">{{$t('indexNew.t3')}}</li>
                        <li><img class="icon" src="@/assets/zpm/zpm-img03.png" alt=""></li>
                        <li class="text">""<span>{{$t('indexNew.t4')}}</span>""</li>
                    </ul>
                    <ul class="item3-zpm-box">
                        <li class="li-text t1">{{$t('indexNew.t6')}}</li>
                        <li class="li-text">{{$t('indexNew.t7')}}</li>
                        <li class="li-text t2">{{$t('indexNew.t4')}}</li>
                    </ul>
                    <div class="tips">{{$t('indexNew.t5')}}</div>
                    <div><img class="arrow-icon" src="@/assets/zpm/zpm-img05.png" alt=""></div>
                </div>
            </div>
        </div>
        <nav-bar :navName="'index'"></nav-bar>
        <loading v-show="isLoad"></loading>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
import loading from '@/components/loading.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
let that = this;
let vm = null;
export default {
    name: 'index',
    data () {
        return {
            theme: false,
            logo: '',
            isShow: false,
            token: '',
            swiper: null,
            websock: null,
            bannerList: [],
            noticeList: [],
            listData: [],
            currencyList: [],
            isNotice: false,
            noticeId: '',
            noticeHtml: '',
            isDownLoad: '',
            isNoticeShow: '',
            isLoad: false,
            service_link: '',
            swiperOption: {
                notNextTick: true,
                loop:true,
                autoplay:{
    　　　　　　　　delay: 4000,
    　　　　　　　　stopOnLastSlide: false,
    　　　　　　　　/* 触摸滑动后是否继续轮播 */
    　　　　　　　　disableOnInteraction: false
    　　　　　　},
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true,
                },
                on:{
                    click: ()=>{
                        let swiper1 = this.$refs.mySwiper.$swiper;
                        let i = swiper1.realIndex;
                        vm.bannerLink(i);
                    }
                }
            },
            swiperOption2: {
                notNextTick: true,
                loop: true,
                direction: "vertical",
                autoplay:{
    　　　　　　　　delay: 4000,    　　　　　　　　
　　　　　　     },
                on:{
                    click: ()=>{
                        let swiper = this.$refs.mySwipers.$swiper;
                        let i = swiper.realIndex;
                        vm.goNotice(i);
                    }
                },
            },
            lang: 'en',
            type: 2,
            zpmShow: false,
		        isZpmShow: '',
            isPhone: false,
            temp_user: false,
            isMn: false
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        vm = this;
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.lang = localStorage.getItem('language') || 'en';
        this.isMn = JSON.parse(localStorage.getItem('isMn')) || false;
    },
    mounted() {
      this.token = localStorage.getItem('token') || '';
      this.isDownLoad = sessionStorage.getItem('isDownLoad') || window.GLOBAL.isDownLoad;
		  this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
      this.isZpmShow = sessionStorage.getItem('isZpmShow');
      this.isPhone = JSON.parse(sessionStorage.getItem('isPhone')) || false;
      if(this.isZpmShow){
        this.zpmShow = false;
      }else{
        this.zpmShow = true;
      }
      if(this.isDownLoad){
        this.isShow = false;
      }else{
        this.isShow = true;
      }
    //   this.getTempLogin();
      this.getBanner();
      this.getGG();
      this.getmarketList();
      this.initWebSocket();
      this.getLogo();
      this.getParams();
      this.getCheckcode();
    },
    methods: {
      getCheckcode(){
        let params = {
            token: 1
        }
        this.$ajax.get('/web/reg_checkcode',{params}).then((res) => {
            let resData = res.data.data;
            this.temp_user = resData.temp_user;
        }).catch(function(err){
            console.log(err)
        })
      },
      create(){
        if(!this.isMn){
          let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
            let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.isMn = true;
                localStorage.setItem('token',resData.data.token);
                localStorage.removeItem('sbsxbz');
                localStorage.removeItem('sbsxIcon');
                localStorage.setItem('isMn',true);
                this.$toast.center(this.$t('status.statusText')[2]);
                setTimeout(() => {
                    this.$router.push('/index');
                  //  window.location.reload();
                }, 1000)
              }else{
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
        }else{
          this.loginOut();
        }
      },
      loginOut(){
        this.isMn = false;
        localStorage.removeItem('token');
        localStorage.removeItem('area_code');
        localStorage.removeItem('city_code');
        localStorage.removeItem('bz');
        localStorage.removeItem('type');
        localStorage.removeItem('tim');
        localStorage.removeItem('type');
        localStorage.removeItem('sbsxbz');
        localStorage.removeItem('sbsxIcon');
        localStorage.removeItem('isMn');
        this.$router.push('/index')
      },
      goUser(){
        this.$router.push('/user')
      },
       zpmClose(){
        if(this.isZpmShow != null){
          this.zpmShow = true;
          sessionStorage.removeItem('isZpmShow');
        }else{
          this.zpmShow = false;
          sessionStorage.setItem('isZpmShow',true);
        }
      },
      tab(id){
        this.type = id;
        this.listData = [];
        this.currencyList = [];
        this.getmarketList();
      },
      service(){
        if(!this.service_link) return;
        var kfUrl;
        var userId = localStorage.getItem('userId');
        if(userId){
          var userInfo = {
            "uid":userId,
            "name":userId
          }
          var userUrl = encodeURIComponent(JSON.stringify(userInfo));
          kfUrl = this.service_link + "&userInfo=" + userUrl;
        }else{
          kfUrl = this.service_link;
        }
        this.$router.push({ path: '/service', query: { url: kfUrl } })
      },
      getParams(){
          this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
              let resData = res.data.data;
              this.service_link = resData.filter((item) =>{
                  if(item.key == 'online_service'){
                      return item
                  }
              })[0].value;
          }).catch(function(err){
              console.log(err)
          })
       },
        getTempLogin(){
		  	  let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
              console.log(res)
          }).catch(function(err){
              console.log(err)
          })
        },
      goDetail(){
          this.$router.push({path: "/notice",query: { id: this.noticeId }});
      },
      goNotice(idx){
          let id = this.noticeList[idx].id;
          this.$router.push({path: "/notice",query: { id: id }});
      },
      bannerLink(i){
          let id = this.bannerList[i].id;
          let content = this.bannerList[i].content;
          if(id){
              if(this.filterHtmlTag(content)){
                  this.$router.push({path: "/bannerDetail",query: { id }});
              }
          }
      },
      noticeClose(){
        if(this.isNoticeShow != null){
        this.isNotice = true;
        sessionStorage.removeItem('isNoticeShow');
			}else{
				this.isNotice = false;
				sessionStorage.setItem('isNoticeShow',true);
			}
       },
       downLoadClose(){
           if(this.isDownLoad){
				this.isShow = true;
				sessionStorage.removeItem('isDownLoad');
			}else{
				this.isShow = false;
				sessionStorage.setItem('isDownLoad',true);
			}
       },
       link(){
           this.$router.push('/downLoad')
       },
       jump(symbol){
         if(this.type == 1){
           this.$router.push({ path: '/contractTransaction', query: { symbol: symbol } })
         }else{
           this.$router.push({ path: '/contractTransaction2', query: { symbol: symbol } })
         }
        },
        jump2(url){
          if(this.isMn){
            this.$toast.center(this.$t('langNew.qdlzszh'));
            return;
          }else{
            this.$router.push({ path: '/deposit', query: { type: 1,url: url } })
          }
        },
       getBanner(){
		  	let params = {
                token:1,
            }
            this.$ajax.get('/web/getBanner',{params}).then((res) => {
                let resData = res.data.data;
                this.bannerList = resData;

            }).catch(function(err){
                console.log(err)
            })
        },
      getGG(id){
            this.$ajax.get('/web/getGG').then((res) => {
              if(res.data.code != 1000){
                var noticeArr = [];
                let resData = res.data.data;
                this.noticeList = resData;
                if(resData.length > 0){
                  noticeArr = resData.filter((item,index) =>{
                  if(item.is_popover == 1){
                    return true;
                  }else{
                    return ''
                  }
                });
                if(noticeArr.length > 0){
                  if(this.isNoticeShow){
                    this.isNotice = false;
                  }else{
                    this.isNotice = true;
                  }
                  this.noticeId = noticeArr[0].id;
                  this.getNotice(this.noticeId);
                }
                }else{
                    this.isNotice = false
                }
              }else{
                this.isNotice = false
              }

          }).catch(function(err){
              console.log(err)
          })
		  },
      getNotice(id){
			  let params = {
              id:id,
            }
            this.$ajax.get('/web/getText',{params}).then((res) => {
                let resData = res.data.data;
                this.noticeHtml = this.contHtml(resData.content);
            }).catch(function(err){
                console.log(err)
            })
	  	},
      getLogo(){
			  let params = {
            key: 'app_logo',
            token:1,
        }
        this.$ajax.get('/web/getLogo',{params}).then((res) => {
          let resData = res.data.data;
          this.logo = resData;
        }).catch(function(err){
            console.log(err)
        })
	  	},
       getmarketList() {
        var that = this;
        let params = {
            type: this.type,
            token: '',
            id: 1,
            classify: 0,
            limit: 100
        }
        that.isLoad = true;
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          var curr;
          that.listData = resData;
          that.currencyList = [];
          for (curr in that.listData){
            that.currencyList[that.listData[curr].currency] = [that.listData[curr].icon,that.listData[curr].symbol];
          }
          that.isLoad = false;
        }).catch(function(err){
            console.log(err)
        })
        },
       initWebSocket(){ //初始化weosocket
            const wsuri = this.socket_url;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据
        },
        websocketonerror(){//连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e){ //数据接收
          let msg = JSON.parse(e.data).content;
          if(JSON.parse(e.data).action == "marketprice"){
            let keyArr = [];
            for(var x in this.currencyList){
              for(var y in this.listData){
                x = this.type == 1 ? x.toLowerCase() : x;
                if(!msg[x]) return;
                if(msg[x].symbol == this.listData[y].symbol){
                  this.listData[y]['new_price'] = msg[x].now_price;
                  this.listData[y]['grow'] = msg[x].change;
                  keyArr.push(this.listData[y]);
                  break;
                }
              }
            }
            this.listData = keyArr;
          }
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
            // console.log('断开连接',e);
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
        filterHtmlTag(msg){
            var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
                msg = msg.replace(/[|]*\n/, '') //去除行尾空格
                msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
                return msg;
        },
    },
    components:{
        navBar,
        Swiper,
        SwiperSlide,
        loading
    },
    beforeDestroy(){
      // this.websock.close(); //离开路由之后断开websocket连接
    },
    // destroyed() {
    //   this.websock.close() //离开路由之后断开websocket连接
    // }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        background: #fff;
        box-sizing: border-box;
    }
    .head .icon{
      position: absolute;
      top: 50%;
      left: .44rem;
      width: 3.5rem;
      /* height: .94rem; */
      transform: translateY(-50%);
    }
    .head .title{
        font-size: .56rem;
    }
    .head .lang{
        position: absolute;
        top: 50%;
        right: .4rem;
        transform: translateY(-50%);
    }
    .head .icon2{
      width: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 2.1rem;
        width: 100%;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .banner-wrap{
      height: 3.92rem;
      margin: 0 .44rem;
    }
    .cotainer .banner-wrap .banner-box{
      height: 100%;
    }
    .cotainer .banner-box .img{
        width: 100%;
        height: 3.92rem;
        border-radius: .2rem;
    }
    .cotainer .notice-box{
        display: flex;
        align-items: center;
        height: 1rem;
        padding: 0 .44rem;
        overflow: hidden;
    }
    .cotainer .notice-box .icon{
        width: .6rem;
    }
    .cotainer .notice-box .notice{
        flex: 1;
        height: 1rem;
        padding: 0 .4rem;
        line-height: 1rem;
        overflow: hidden;
    }
    .cotainer .notice-box .notice .swiper-container{
        height: 1rem;
    }
    .cotainer .notice-box .notice .text{
        color: #000;
        font-size: .4rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .cotainer .notice-box .arrow{
      width: .3rem;
    }
    .cotainer .coin-box{
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        margin: .3rem .32rem 0;
        overflow-x: scroll;
    }
    .cotainer .coin-box .coin-li{
        padding: .2rem .3rem .16rem;
        text-align: center;
    }
    .cotainer .coin-box .coin-head{
        display: flex;
        align-items: center;
    }
    .cotainer .coin-box .coin-head .icon{
        width: .59rem;
        height: .59rem;
    }
    .cotainer .coin-box .coin-head .text{
        color: #000;
        font-size: .35rem;
        padding-left: .2rem;
    }
    .cotainer .coin-box .coin-head .text .t1{
        color: #b0b0b0;
    }
    .cotainer .coin-box .price{
        padding: .3rem 0 .2rem;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .coin-box .change{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #49d674;
    }
    .cotainer .coin-box .change .arrow{
        height: .8rem;
        margin-right: .1rem;
    }
     .cotainer .coin-box .change .arrow.die{
         transform: rotate(180deg);
     }
    .cotainer .line{
        width: 100%;
        height: .18rem;
        background: #f9f9f9;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-flow: wrap;
    }
    .cotainer .item-box .item{
        width: 25%;
        padding: .4rem 0;
        text-align: center;
    }
    .cotainer .item-box .item .icon{
        /* width: .72rem; */
        height: .8rem;
    }
    .cotainer .item-box .item .text{
        padding-top: .3rem;
        color: #000;
        font-size: .34rem;
    }
    .cotainer .table-head{
        display: flex;
        align-items: center;
        padding: .4rem .32rem 0;
    }
    .cotainer .table-head .th{
        width: 33.33%;
        color: #7f7f7f;
        font-size: .35rem;
    }
    .cotainer .table-body{
        padding: 0 .4rem;
    }
    .cotainer .table-body .tr{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .4rem 0;
        border-bottom: 1px solid #eee;
    }
    .cotainer .table-body .tr .item{
        width: 33.33%;
    }
    .cotainer .table-body .coin{
        display: flex;
        align-items: center;
    }
    .cotainer .table-body .coin .icon{
        width: .94rem;
        height: .94rem;
        margin-right: .3rem;
    }
    .cotainer .table-body .coin .t1{
        color: #000;
        font-size: .38rem;
    }
    .cotainer .table-body .coin .t2{
        color: #b0b0b0;
        font-size: .32rem;
    }
    .cotainer .table-body .price{
        color: #000;
        font-size: .48rem;
    }
    .cotainer .table-body .change .persent{
        display: inline-block;
        width: 2rem;
        padding: 6px;
        color: #fff;
        border-radius: 4px;
        background: #00c483;
        text-align: center;
    }
    /* 公告弹窗 */
    .notice-wrap{
        position: fixed;
        left: 5%;
        right: 5%;
        top: 50%;
        z-index: 12;
        width: 90%;
        padding: 0 6px;
        border-radius: 4px;
        background: #fff;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .notice-wrap .title{
        padding: 10px;
        color: #000;
        font-size: 15px;
        text-align: center;
    }
    .notice-wrap .cont{
        min-height: 80px;
        max-height: 200px;
        padding: 10px;
        color: #666;
        font-size: 12px;
        word-break: break-word;
        overflow-y: auto;
    }
    .notice-wrap .notice-btn{
        height: 36px;
        margin: 10px 10px 20px;
        line-height: 36px
    }
    .notice-wrap .btn-close{
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
    }
    /* 下载框 */
    .download-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        left: 2%;
        bottom:2.1rem;
        width: 96%;
        height: 60px;
        padding: 0 5px;
        border-radius: 4px;
        background: #3381d5;
        box-sizing: border-box;
    }
    .download-box .logo{
        height: 25px;
    }
    .download-box .text-box .t1{
        font-size: 13px;
        margin-bottom: 4px;
    }
    .download-box .text-box{
        flex: 1;
        margin: 0 5px;
        color: #fff;
        font-size: 12px;
    }
    .download-box .btn{
        margin-right: 15px;
        padding: 5px 10px;
        color: #000;
        font-size: 12px;
        border-radius: 4px;
        background: #fff;
        text-align: center;
    }
    .download-box .btn-close{
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 999;
        width: 12px;
        height: 12px;
    }
    .tab-box{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: .42rem 0;
    }
    .tab-box .tab{
      position: relative;
      padding: 0 .5rem;
      color: #150700;
      font-size: .52rem;
    }
    .tab-box .tab.active::after{
      position: absolute;
      left: 50%;
      bottom: -.2rem;
      content: '';
      width: .78rem;
      height: .06rem;
      background: #2d66cf;
	    border-radius: 0.03rem;
      transform: translateX(-50%);
    }
    .alert-zpm-wrap{
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
  }
  .alert-zpm-wrap .alert-zpm-box{
    position: absolute;
    bottom: 0;
    z-index: 100;
    width: 100%;
    border-radius: 6px 6px 0 0;
    background: #fff;
    overflow-y: scroll;
  }
  .alert-zpm-wrap .zpm-head{
    padding: 12px 18px 0;
  }
  .alert-zpm-wrap .zpm-head .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .alert-zpm-wrap .zpm-head .t1{
    flex: 1;
    color: #000;
    font-size: 15px;
  }
  .alert-zpm-wrap .zpm-head .close{
    width: 18px;
  }
  .alert-zpm-wrap .zpm-head .t2{
    padding: 10px 0;
    color: #a1a1a1;
    font-size: 12px;
  }
  .alert-zpm-wrap .zpm-cont{
    position: relative;
    padding: 0 5px;
    color: #000;
    font-size: 14px;
    text-align: center;
  }
   .alert-zpm-wrap .zpm-cont .zpm-logo{
     position: absolute;
     left: 50%;
     top: 0;
     width: 50px;
     height: 50px;
     transform: translateX(-50%);
   }
   .alert-zpm-wrap .zpm-cont .zpm-title{
     position: absolute;
     top: 55px;
     left: 0;
     right: 0;
     color: #000;
     font-size: 14px;
   }
  .alert-zpm-wrap .zpm-cont .img{
    width: 150px;
    margin: auto;
  }
  .alert-zpm-wrap .zpm-cont .item1-zpm-box{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 10px 0; */
  }
  .alert-zpm-wrap .zpm-cont .item1-zpm-box .icon{
    width: 40px;
  }
  .alert-zpm-wrap .zpm-cont .item2-zpm-box{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .alert-zpm-wrap .zpm-cont .item2-zpm-box .text{
    font-size: 14px;
  }
  .alert-zpm-wrap .zpm-cont .item2-zpm-box .icon{
    width: 40px;
    margin: 0 8px;
  }
  .alert-zpm-wrap .zpm-cont .item3-zpm-box{
    width: 280px;
    height: 120px;
    margin: auto;
    background: url('../assets/zpm/zpm-img04.png') no-repeat center center;
    background-size: cover;
  }
  .alert-zpm-wrap .zpm-cont .li-text{
    height: 34px;
    padding: 0 30px;
    color: #000;
    line-height: 34px;
    font-size: 12px;
    text-align: left;
  }
  .alert-zpm-wrap .zpm-cont .li-text.t1{
    padding-top: 4px;
  }
  .alert-zpm-wrap .zpm-cont .li-text.t2{
    font-size: 13px;
    font-weight: bold;
  }
  .alert-zpm-wrap .zpm-cont .tips{
    padding: 0 0 10px;
    font-size: 12px;
  }
  .alert-zpm-wrap .zpm-cont .arrow-icon{
    width: 40px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue